// Reference split of the Andar Bahar 50 / 150 feed `card` string for the video sliders:
// index even → Bahar, odd → Andar ("1" = not dealt, skipped), each reversed (newest first).
export function splitAbCards(cardString) {
  const cards = cardString ? String(cardString).split(",") : [];
  const andar = [];
  const bahar = [];
  cards.forEach((c, i) => {
    if (c === "1") return;
    if (i % 2 === 0) bahar.push(c);
    else andar.push(c);
  });
  return { cards, andar: andar.reverse(), bahar: bahar.reverse() };
}
